import ClassNames from '@streamloots/classnames';
import { PageFeed } from 'model/indexTS';
import { TranslateInterface } from 'utils/translation';
import { ActionWithLogin } from '../action-with-login';
import { ButtonTips } from '../checkout-tips';
import { FooterButton } from '../footer-button';
import { useFeedList } from './useFeedList';
import { ShareButton } from './ShareButton';
import theme from './feed-list.scss';

const classNames = ClassNames(theme);

export interface FeedFooterProps extends TranslateInterface {
  feed: PageFeed;
  showingComments: boolean;
  onCommentClick: () => void;
}

const LOCATION = 'feed content';

export const FeedFooter = ({ feed, showingComments, onCommentClick, t }: FeedFooterProps): JSX.Element => {
  const { isUserAuthenticated, page, handleLikeClick, isStaff, user } = useFeedList();

  const onLikeClick = () => {
    handleLikeClick(feed);
  };

  const disableButtons = !feed.visible && !page.modules?.subscriptions?.enabled;

  return (
    <div className={classNames('feed-detail__footer')}>
      <div className="flex items-center">
        <ActionWithLogin feed={feed} page={page} isAuthenticaded={isUserAuthenticated} location="like feed content">
          <FooterButton
            active={feed.summary.liked}
            buttonId={feed.summary.liked ? 'unlike' : 'like'}
            commentCount={feed.summary.commentCount}
            disabled={disableButtons}
            contentId={feed._id}
            icon="heart"
            label={feed.summary.reactionCount > 0 ? `${feed.summary.reactionCount}` : ''}
            likeCount={feed.summary.liked ? feed.summary.reactionCount - 1 : feed.summary.reactionCount + 1}
            onClick={onLikeClick}
            title={feed.summary.liked ? t('pageFeed:feedDetail.summary.unlike') : t('pageFeed:feedDetail.summary.like')}
            location={LOCATION}
          />
        </ActionWithLogin>
        <ActionWithLogin feed={feed} page={page} isAuthenticaded={isUserAuthenticated} location="like feed content">
          <FooterButton
            active={feed.summary.hasCommented}
            buttonId={showingComments ? 'hide comments' : 'show comments'}
            commentCount={feed.summary.commentCount}
            disabled={disableButtons}
            contentId={feed._id}
            icon={feed.summary.hasCommented ? 'feedback' : 'comment-reply'}
            label={feed.summary.commentCount > 0 ? `${feed.summary.commentCount}` : ''}
            likeCount={feed.summary.reactionCount}
            onClick={onCommentClick}
            title={
              showingComments
                ? t('pageFeed:feedDetail.summary.hideComments')
                : t('pageFeed:feedDetail.summary.seeComments')
            }
            location={LOCATION}
          />
        </ActionWithLogin>
      </div>
      <ButtonTips user={user} isStaff={isStaff} feed={feed} page={page} isUserAuthenticated={isUserAuthenticated} />
      <ActionWithLogin
        allowAnonymous
        isAuthenticaded={isUserAuthenticated}
        feed={feed}
        page={page}
        location="share post modal"
      >
        <ShareButton feed={feed} t={t} />
      </ActionWithLogin>
    </div>
  );
};
